/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreModule } from '@dm/core';
import { BadgeNumModule } from 'app/common/components/badge-num/badge-num.module';

import { AlarmsAndEventsService } from '../alarms-and-events.service';
import { AlarmsSettingComponent } from '../alarms-setting/alarms-setting.component';
import { AlarmsPanelComponent } from './alarms-panel.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        RouterModule,
        FormsModule,
        BadgeNumModule,
    ],
    declarations: [
        AlarmsPanelComponent,
        AlarmsSettingComponent,
    ],
    providers: [
        AlarmsAndEventsService,
    ],
    exports: [
        AlarmsPanelComponent,
    ],
})
export class AlarmsPanelModule { }
